module.exports = __webpack_public_path__ + "img/Icon_coin_no-border.35772740.png";